module.exports = __webpack_public_path__ + "img/attention.75730609.svg";